import React, { useRef, useEffect } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/core/styles"
import { Formik, Form } from "formik"
import { Box, Typography } from "@material-ui/core/"
import * as Yup from "yup"
import ReusableFormControl from "../../../../components/ReusableFormControl"
import MaskedSubDomain from "../../../../components/MaskedSubDomain"

const OrganizationInformationSchema = Yup.object().shape({
  organizationName: Yup.string().required("Required"),
  organizationSubDomain: Yup.string().required("Required")
})

const Step1Organization = ({ classes, data }) => {
  const formRef = useRef()
  const { setFormRef, formSubmit, setFormData, formState } = data
  useEffect(() => {
    setFormRef(formRef)
  }, [])
  useEffect(() => {}, [formState])

  return (
    <Box>
      <Formik
        innerRef={formRef}
        initialValues={{
          organizationName: formState.organizationName,
          organizationSubDomain: formState.organizationSubDomain
        }}
        validationSchema={OrganizationInformationSchema}
        onSubmit={formSubmit}
      >
        {formikProps => {
          const handleChange = formikProps.handleChange
          formikProps.handleChange = e => {
            if (
              e.target.id === "organizationName" &&
              formikProps.touched.organizationSubDomain !== true
            ) {
              formikProps.handleChange({
                target: {
                  id: "organizationSubDomain",
                  name: "organizationSubDomain",
                  value: e.target.value.replace(/[^\w\d]/g, "").toLowerCase()
                }
              })
            }
            handleChange(e)
            setFormData(e)
          }
          return (
            <Box className={classes.codeInputContainer}>
              <Form ref={formRef}>
                <ReusableFormControl
                  name={"organizationName"}
                  label="Organization Name"
                  formikProps={formikProps}
                  inputClass={classes.inputReusableFormControl}
                  inputLabelClass={classes.labelTextColor}
                />
                <Typography
                  variant="h6"
                  className={classes.subdomainExplanation}
                >
                  Create your organizations sub domain
                </Typography>
                <Typography className={classes.subDomainText} variant="body1">
                  This domain will be unique to your organization and give your
                  members easy access to find your organization. Please note
                  that once it is made, it cannot be changed.
                </Typography>
                <ReusableFormControl
                  name="organizationSubDomain"
                  label="Organization Sub Domain"
                  formikProps={formikProps}
                  inputProps={{
                    inputComponent: MaskedSubDomain
                  }}
                  value={formState.organizationName.toLowerCase()}
                  inputClass={classes.inputReusableFormControl}
                  inputLabelClass={classes.labelTextColor}
                />
                <Typography variant="h6" className={classes.subdomainContainer}>
                  https://
                  <span className={classes.subdomain}>
                    {formState.organizationSubDomain.length <= 55
                      ? formState.organizationSubDomain.toLowerCase()
                      : formState.organizationSubDomain.slice(0, 55)}
                  </span>
                  .firstlinesocial.com
                </Typography>
              </Form>
            </Box>
          )
        }}
      </Formik>
    </Box>
  )
}

export default withStyles(styles)(Step1Organization)



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step1Organization/index.jsx